const primaryMain = '#006A4D';
const primaryMainOpacity = 'rgba(0, 106, 77, 0.9)';
const secondaryMain = '#003359';
const secondaryMainOpacity = 'rgba(0, 51, 89, 0.5)';
const secondaryLight = '#69B328';
const tertiaryMain = '#F9F9F9';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  contrastText: primaryMain,
  logoContainerMobile: {
    height: 30,
    marginBottom: 20
  },
  headerColor: tertiaryMain,
  formNavBar: {
    stepperBackgroundColor: primaryMain
  }
};
